<div class="header">
  <div class="search">
    @if(!back()) {
      <button class="start">
        @if(loading()) {
          <ion-spinner name="crescent" />
        } @else {
          <ion-icon name="search" />
        }
      </button>
    } @else {
      <button (click)="backAction()" class="start">
        <ion-icon name="arrow-back" />
      </button>
    }
    

    <input autocapitalize="none" #search type="text" (focusout)="inputFocusOut()" (focus)="inputFocus()" [(ngModel)]="searchText" placeholder="Search for pharmacy products">
    @if(searchText()) {
      <button (click)="clearSearch()" class="end">
        <ion-icon name="close-circle" />
      </button>
    }
  </div>
</div>